if(!customElements.get('snl-mobile-comparison')){
 customElements.define('snl-mobile-comparison',class extends HTMLElement{
  connectedCallback(){
   if(this.initialized)return;
   this.initialized=true;
   this.choices=[...this.querySelectorAll('[data-choice]')];
   this.panels=[...this.querySelectorAll('[data-panel]')];
   this.querySelector('.snlCompare__controls').hidden=false;
   this.select('1');
   this.addEventListener('click',event=>{
    const button=event.target.closest('[data-choice]');
    if(button&&this.contains(button))this.select(button.dataset.choice);
   });
  }
  select(value){
   this.choices.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.choice===value)));
   this.panels.forEach(panel=>panel.hidden=panel.dataset.panel!==value);
  }
 });
}
